var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseList',{staticClass:"physical-object-list",attrs:{"list-query":_vm.objects,"name-map":_vm.nameMap,"route":"object","sort":(o1, o2) => {
        let a1 = o1.artefact || this.$t('pages.artefacts.unknown');
        let a2 = o2.artefact || this.$t('pages.artefacts.unknown');
        return a1.localeCompare(a2, 'sv');
      },"locale-section":"pages.physicalObjects"},scopedSlots:_vm._u([{key:"extra",fn:function({ element }){return [_vm._v(" "+_vm._s(_vm.$t("pages.physicalObjects.of"))+" "+_vm._s(element.material ? element.material.toLowerCase() : _vm.$t("pages.materials.unknown"))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }